export const api_paths = {
    CATEGORY: {
        get: "/category"
    },
    PROJECT: {
        get: "/project"
    },
    SERVICES: {
        get: "/service"
    },
    CONTACT: {
        post: "/contact"
    },
    CMS: {
        get: "/cms"
    }
}